import React from 'react';
import './Styles/InvisibleButton.css';

export const InvisibleButton = props => {
  const classes = props.show ? 'InvisibleButton' : 'InvisibleButton--Hidden';
  return (
    <div className={classes} onClick={() => props.click()}>
      {props.text}
    </div>
  );
};
